import Keycloak from 'keycloak-js'

export const createKeycloak = config => new Keycloak(config)
